import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {getYear, isValid} from 'date-fns';
import {Loading, Divider, Toast} from "spectre-react/dist/cjs";
import WagesParamsDemonstration from "./WagesParamsDemonstration";
import TimeNavigation from "../shared/other/TimeNavigation";
import SelectionModeNotificationBlock from "../shared/wages_params/SelectionModeNotificationBlock";
import WagesTestParamsModal from "../shared/wages_params/WagesTestParamsModal";
import {getWagesEngineersTablePageData} from "../../api";
import {setWagesParamsSelectionModeEnabled, setWagesTableFilter,} from "../../store/actions";
import {isoFmt, pluralize, roundToOne, roundToTwo, rubFmt} from "../shared/utils";


class WagesTablePage extends React.PureComponent {
    static propTypes = {
        pageFilters: PropTypes.object.isRequired,
        setPageFilters: PropTypes.func.isRequired,
        isSelectionModeEnabled: PropTypes.bool.isRequired,
        setSelectionModeEnabled: PropTypes.func.isRequired,
    };

    state = {
        isLoading: true,
        loadingError: undefined,

        engineerNames: {},

        // startDate: isoFmt(startOfQuarter(new Date())),
        // endDate: isoFmt(endOfQuarter(new Date())),

        engineersPersonalStats: undefined,
        engineersTotalStats: undefined,

        showSelectionModeBlock: this.props.isSelectionModeEnabled
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const entries = nextProps.engineers.map(({_id, nameLF}) => [_id, nameLF]);
        const engineerNames = Object.fromEntries(entries);

        return {engineerNames};
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.pageFilters.startDate !== this.props.pageFilters.startDate ||
            prevProps.pageFilters.endDate !== this.props.pageFilters.endDate ||
            prevProps.isSelectionModeEnabled !== this.props.isSelectionModeEnabled
        )
            this.fetchData();
    }

    fetchData = async () => {
        if (!this.areStartAndEndDateValid())
            return;

        try {
            this.setState({isLoading: true, loadingError: undefined});
            const {pageFilters: {startDate, endDate}, isSelectionModeEnabled} = this.props;
            const {engineersStats, totalData} = await getWagesEngineersTablePageData(startDate, endDate, isSelectionModeEnabled);
            this.setState({isLoading: false, engineersPersonalStats: engineersStats, engineersTotalStats: totalData});
        } catch (error) {
            console.error(error);
            this.setState({isLoading: false, loadingError: error});
        }
    };


    onTimespanChange = ({startDate, endDate, mode}) => {
        startDate = isoFmt(startDate);
        endDate = isoFmt(endDate);
        this.props.setPageFilters({startDate, endDate, timespanMode: mode});
    }

    areStartAndEndDateValid() {
        const {startDate, endDate} = this.props.pageFilters;

        if (!startDate || !endDate)
            return false;

        const start = new Date(startDate), end = new Date(endDate);

        if (!isValid(start) || !isValid(end))
            return false;

        return start <= end &&
            2010 <= getYear(start) && getYear(start) <= 2030 &&
            2010 <= getYear(end) && getYear(end) <= 2030;
    }

    // ***** //

    paramsModalRef = new React.createRef();

    toggleSelectionMode = (ev) => this.props.setSelectionModeEnabled(ev.target.checked);

    openSelectionModeModal = () => this.paramsModalRef.current?.openModal();

    // ***** //

    renderStatsBodyCells(engineerId) {
        const data = this.state.engineersPersonalStats[engineerId];

        return (
            <>
                <td className="text-center">
                    {data.vacation.days} <span className="text-tiny text-italic">д.</span></td>
                <td className="text-center">
                    {data.illness.days} <span className="text-tiny text-italic">д.</span></td>
                <td className="text-center">
                    {data.total.reports} <span className="text-tiny text-italic">{pluralize(data.total.reports, 'репортов', 'репорт', 'репорта', 'репортов')}</span><br/>
                    {data.inTrips.reports} <span className="text-tiny text-italic">{pluralize(data.inTrips.reports, 'командировок', 'командировка', 'командировки', 'командировок')}</span></td>
                <td className="text-center">
                    {roundToTwo(data.total.daysCoeff)} <span className="text-tiny text-italic">по д.</span><br/>
                    {roundToTwo(data.total.hoursCoeff)} <span className="text-tiny text-italic">по ч.</span></td>
                <td className="text-center">
                    {roundToOne(data.period.workingDays)} <span className="text-tiny text-italic">д.</span><br/>
                    {roundToOne(data.period.workingHours)} <span className="text-tiny text-italic">ч.</span></td>
                <td className="text-center">
                    {roundToOne(data.total.days)} <span className="text-tiny text-italic">д.</span><br/>
                    {roundToOne(data.total.hours)} <span className="text-tiny text-italic">ч.</span></td>
                <td className="text-center">
                    {roundToOne(data.inTrips.days)} <span className="text-tiny text-italic">д.</span><br/>
                    {roundToOne(data.inTrips.hours)} <span className="text-tiny text-italic">ч.</span></td>
                <td className="text-center">
                    {roundToOne(data.homeCity.days)} <span className="text-tiny text-italic">д.</span><br/>
                    {roundToOne(data.homeCity.hours)} <span className="text-tiny text-italic">ч.</span></td>
                <td className="text-center">
                    {roundToOne(data.onWeekend.days)} <span className="text-tiny text-italic">д.</span><br/>
                    {roundToOne(data.onWeekend.hours)} <span className="text-tiny text-italic">ч.</span></td>
                <td className="text-center">
                    {roundToOne(data.overtime.days)} <span className="text-tiny text-italic">д.</span><br/>
                    {roundToOne(data.overtime.hours)} <span className="text-tiny text-italic">ч.</span></td>
            </>
        );
    }


    renderFirstTableRow(engineerId) {
        /* ------------- ACHTUNG: hard-code ------------- */
        if (engineerId === "brylev_r")
            return null;
        /* ---------------------------------------------- */

        const data = this.state.engineersPersonalStats[engineerId];
        const name = this.state.engineerNames[engineerId];

        if (!data)
            return null;

        const shortName = name.slice(0, name.indexOf(' ') + 2) + '.';

        return (
            <tr key={engineerId} data-engineer-id={engineerId}>
                <td className="text-bold text-uppercase text-nowrap">{shortName}</td>
                <td className="text-center">{rubFmt(data.manualBonus.payAmount)}</td>
                <td className="text-center">{rubFmt(data.vacation.payAmount)}</td>
                <td className="text-center">{rubFmt(data.illness.payAmount)}</td>
                <td className="text-center">{rubFmt(data.home.payAmount)}</td>
                <td className="text-center">{rubFmt(data.office.payAmount)}</td>
                <td className="text-right">{rubFmt(data.homeCity.payAmount)}</td>
                <td className="text-right">{rubFmt(data.inTrips.payAmount)}</td>
                <td className="text-right">{rubFmt(data.travel.payAmount)}</td>
                <td className="text-right">{rubFmt(data.total.payAmount)}</td>
                <td className="text-right">{rubFmt(data.total.meanPayAmount)}</td>
            </tr>
        )
    }

    renderFirstTableTotalRow() {
        const totalData = this.state.engineersTotalStats;

        return (
            <tr className="bg-dawn-pink">
                <td>Итого:</td>
                <td className="text-center">{rubFmt(totalData.manualBonusPay)}</td>
                <td className="text-center">{rubFmt(totalData.vacationPay)}</td>
                <td className="text-center">{rubFmt(totalData.illnessPay)}</td>
                <td className="text-center">{rubFmt(totalData.homePay)}</td>
                <td className="text-center">{rubFmt(totalData.officePay)}</td>
                <td className="text-right">{rubFmt(totalData.homeCityPay)}</td>
                <td className="text-right">{rubFmt(totalData.tripsPay)}</td>
                <td className="text-right">{rubFmt(totalData.travelPay)}</td>
                <td className="text-right">{rubFmt(totalData.totalPay)}</td>
                <td className="text-right">{rubFmt(totalData.totalMeanPay)}</td>
            </tr>
        );
    }


    renderSecondTableRow(engineerId) {
        const data = this.state.engineersPersonalStats[engineerId];

        if (!data)
            return null;

        const name = this.state.engineerNames[engineerId];
        const shortName = name.slice(0, name.indexOf(' ') + 2) + '.';

        return (
            <tr key={engineerId} data-engineer-id={engineerId}>
                <td className="text-bold text-uppercase text-nowrap">{shortName}</td>
                {this.renderStatsBodyCells(engineerId)}
            </tr>
        );
    }


    renderPageParams() {
        const {startDate, endDate, timespanMode} = this.props.pageFilters;
        const {isSelectionModeEnabled} = this.props;
        const {showSelectionModeBlock} = this.state;

        return (
            <div className="d-flex flex-centered">
                <TimeNavigation
                    defaultMode={timespanMode}
                    onChange={this.onTimespanChange}
                    defaultStartDate={startDate}
                    defaultEndDate={endDate}
                />
                {showSelectionModeBlock && (
                    <SelectionModeNotificationBlock
                        wrapperClassName="flex-1 ml-2 my-2 py-1 bg-light-aqua"
                        onTextClick={this.openSelectionModeModal}
                        onSwitchClick={this.toggleSelectionMode}
                        isEnabled={isSelectionModeEnabled}
                    />
                )}
            </div>
        )
    }

    render() {
        const { isLoading, loadingError } = this.state;
        const isFirstPageLoad = !this.state.engineersPersonalStats;

        if (isLoading && isFirstPageLoad)
            return <Loading large />;

        if (loadingError)
            return <Toast error>{loadingError.toString()}</Toast>;

        const { engineerNames, showSelectionModeBlock } = this.state;

        const engineers = Object.entries(engineerNames)
            .map(([_id, name]) => ({_id, name}))
            .sort((a, b) => a.name.localeCompare(b.name));

        return (
            <div className="container" id="wages-engineers-table-page">
                {showSelectionModeBlock && (
                    <WagesTestParamsModal
                        ref={this.paramsModalRef}
                        onParamsSubmit={this.fetchData}
                    />
                )}

                <div className="columns">
                    <div className="column col-12">
                        <WagesParamsDemonstration />
                    </div>
                    <div className="column col-12">
                        <Divider />
                    </div>
                    <div className="column col-12">
                        {this.renderPageParams()}
                    </div>
                </div>

                <Divider />

                <table className="table table-striped">
                    <thead>
                        <tr className="text-tiny text-center">
                            <th>{isLoading && !isFirstPageLoad && <Loading />}</th>
                            <th>Бонус</th>
                            <th>Отпускные</th>
                            <th>Больничные</th>
                            <th>Дом</th>
                            <th>Офис</th>
                            <th>СПб</th>
                            <th>Командировки</th>
                            <th>Дорога (расч.)</th>
                            <th>Всего</th>
                            <th>Всего ср-мес</th>
                        </tr>
                    </thead>
                    <tbody>
                    {engineers.map(({_id}) => this.renderFirstTableRow(_id))}
                    {this.renderFirstTableTotalRow()}
                    </tbody>
                </table>

                <div className="divider my-4"/>

                <table className="table table-striped">
                    <thead>
                        <tr className="text-tiny text-center">
                            <th>{isLoading && !isFirstPageLoad && <Loading />}</th>
                            <th>В отпуске</th>
                            <th>Болел</th>
                            <th>Занесено</th>
                            <th>Занятость</th>
                            <th>Рабочих</th>
                            <th>На выездах</th>
                            <th>В командировках</th>
                            <th>В СПб</th>
                            <th>В нерабочее</th>
                            <th>Овертайм</th>
                        </tr>
                    </thead>
                    <tbody>
                    {engineers.map(({_id: engineerId}) => this.renderSecondTableRow(engineerId))}
                    </tbody>
                </table>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        engineers: state.engineers,
        pageFilters: state.wagesEngineersTablePage,
        isSelectionModeEnabled: state.wagesParamsSelectionModeEnabled
    }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    setPageFilters: (state) => dispatch(setWagesTableFilter(state)),
    setSelectionModeEnabled: (flag) => dispatch(setWagesParamsSelectionModeEnabled(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(WagesTablePage);
